import {
  VALIDATE_PHONE,
  GET_BUSINESS,
  REGISTER_OR_UPDATE_BUSINESS,
  GET_STATEMENTS
} from './business.constants';
import * as Redux from 'redux';
import { ReduxPromiseAction } from '../app/app.types';
import { BusinessActionTypes, BusinessResponse, CreateUpdateRequestParameters } from './business.types';
import { SimpleResponse } from '../app/app.types';
import { callApi } from '../util/ApiCaller';
import { pickAuthOrImpersonationToken } from '../util/token.util';

export const validateBusinessPhoneNumber: Redux.ActionCreator<
  ReduxPromiseAction<
    BusinessActionTypes, SimpleResponse<BusinessResponse>
  >
> = (phone: string): ReduxPromiseAction<BusinessActionTypes, SimpleResponse<BusinessResponse>> => ({
  type: VALIDATE_PHONE,
  payload: callApi(
    process.env.REACT_APP_API + '/business/input/validation',
    false,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({phone})
    }
  )
});  

export const getBusiness: Redux.ActionCreator<
  ReduxPromiseAction<
    BusinessActionTypes, SimpleResponse<BusinessResponse>
  >
> = (): ReduxPromiseAction<BusinessActionTypes, SimpleResponse<BusinessResponse>> => {
    return {
      type: GET_BUSINESS,
      payload: callApi(
        process.env.REACT_APP_API + '/business',
        true,
        {
          method: 'GET',
          headers: {
            'Authorization': pickAuthOrImpersonationToken()
          }
        }
      )
    };
  };

export const registerOrUpdateBusiness: Redux.ActionCreator<
  ReduxPromiseAction<
    BusinessActionTypes, SimpleResponse<BusinessResponse>
  >
> = (requestParam: CreateUpdateRequestParameters, createMode: boolean): ReduxPromiseAction<
  BusinessActionTypes, SimpleResponse<BusinessResponse>
> => ({
  type: REGISTER_OR_UPDATE_BUSINESS,
  payload: callApi(
    process.env.REACT_APP_API + '/business',
    true,
    {
      method: createMode ? 'POST' : 'PATCH',
      headers: {
        'Authorization': pickAuthOrImpersonationToken()
      },
      body: ((): FormData => {
        let formData = new FormData();
        formData.append(
          'data',
          JSON.stringify(
            {
              name: requestParam.name,
              clientId: requestParam.clientId,
              address: requestParam.address, 
              city: requestParam.city,
              province: requestParam.province,
              country: requestParam.country,
              postalCode: requestParam.postalCode.toUpperCase(),
              mobile: requestParam.mobile,
              phone: requestParam.phone,
              servicePackage: requestParam.servicePackage,
              timeZone: requestParam.timeZone,
              accountHolderName: requestParam.accountHolderName,
              financialInstitutionName: requestParam.financialInstitutionName,
              transitNumber: requestParam.transitNumber,
              financialInstitutionNumber: requestParam.financialInstitutionNumber,
              bankAccountNumber: requestParam.bankAccountNumber,
              pointPerAttendance: requestParam.pointPerAttendance,
              directDepositStatus: requestParam.directDepositStatus,
              creditCardStatus: requestParam.creditCardStatus,
              cardNumber: requestParam.cardNumber,
              cardHolderName: requestParam.cardHolderName,
              cvc: requestParam.cvc,
              expiryMonth: requestParam.expiryMonth,
              expiryYear: requestParam.expiryYear,
              directDepositId: requestParam.directDepositId,
              creditCardId: requestParam.creditCardId,
              tags: requestParam.tags,
              failedCheckinNotificationCcEmails: requestParam.failedCheckinNotificationCcEmails,
              failedCheckinNotificationCcPhoneNumbers: requestParam.failedCheckinNotificationCcPhoneNumbers,
              failedCheckinEmail: requestParam.failedCheckinEmail,
              failedCheckinSms: requestParam.failedCheckinSms,
              smsDelay: requestParam.smsDelay,
              timeBasedMultipleCheckin: requestParam.timeBasedMultipleCheckin,
              sendCheckinNotificationToMobile2: requestParam.sendCheckinNotificationToMobile2
            }
          )
        );
        
        if (requestParam.logoFile) {
          formData.append('file', requestParam.logoFile);
        }
        
        return formData;
      })()
    }
  )
});

export const getStatements: Redux.ActionCreator<
  ReduxPromiseAction<
    BusinessActionTypes, SimpleResponse<{}>
  >
> = (): ReduxPromiseAction<
  BusinessActionTypes, SimpleResponse<{}>
> => ({
  type: GET_STATEMENTS,
  payload: callApi(
    process.env.REACT_APP_API + '/business/statement/list',
    true,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      }
    }
  )
});



// WEBPACK FOOTER //
// ./src/business/business.actions.tsx